import { render, staticRenderFns } from "./ETicket.vue?vue&type=template&id=2ff28afc&"
import script from "./ETicket.vue?vue&type=script&lang=js&"
export * from "./ETicket.vue?vue&type=script&lang=js&"
import style0 from "./ETicket.vue?vue&type=style&index=0&id=2ff28afc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports